module.exports = __webpack_public_path__ + "static/media/162.a1a56051.jpg";